import { Injectable } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { LetterSf6Api } from "../../../shared/nestjs/gd-integrated/services/letter.api";
import { WorkFlowApiProvider } from "../../../shared/nestjs/workflow/workflow-api";
import { map } from "rxjs/operators";
import { Platform } from "ionic-angular";
import { FileDownloaderProvider } from "../../../providers/file-downloader/file-downloader";
import saveAs from 'file-saver';
import { AnalyticsProvider } from "../../../providers/analytics/analytics";
import { EventNameAnalytics } from "../../../helpers/event-name-analytics";

@Injectable()
export class LetterBloc {
  subscriptions: Array<Subscription> = [];
  SFGoAuth: any;

  constructor(
    public letterSf6Api: LetterSf6Api,
    private workFlowApiProvider: WorkFlowApiProvider,
    private platform: Platform,
    private fileDownloaderProvider: FileDownloaderProvider,
    private analyticsProvider: AnalyticsProvider
  ) {
  }

  dispose() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  add(data): Observable<any> {
    return this.letterSf6Api.add(data);
  }

  save(data): Observable<any> {
    return this.letterSf6Api.save(data);
  }

  delete(data): Observable<any> {
    return this.letterSf6Api.delete(data);
  }

  async getType() {
    return new Promise<any>(async (resolve, reject) => {
      this.subscriptions.push(
        this.letterSf6Api.type().subscribe(result => {
          let templateTypeList = [];
          if (result.data) {
            let objTemplate = {
              templateCode: '0',
              templateCodeDisplay: 'Select',
            }
            templateTypeList.push(objTemplate)

            for (const val of result.data) {
              let obj = {
                templateCode: val.templateCode,
                templateCodeDisplay: val.templateCode,
              }
              templateTypeList.push(obj)
            }
          }
          resolve(templateTypeList);
        }, error => {
          reject(error)
          console.log("error", error);
        }
        )
      )
    })
  }

  async historyById(payload): Promise<void> {
    return new Promise<any>(async (resolve, reject) => {
      this.subscriptions.push(
        this.letterSf6Api.historyById(payload.requestNo).subscribe(async result => {
          let historyData: any = [];
          if (result.data) {
            historyData = result.data;
            historyData['requestedbyuserid'] = historyData.requestedBy.userId;
            historyData['requestedbyname'] = historyData.requestedBy.fullName;
            historyData['requestedbyphoto'] = historyData.requestedBy.photo;
            historyData['requestforuserid'] = historyData.requestFor.userId;
            historyData['requestforname'] = historyData.requestFor.fullName;
            historyData['requestforphoto'] = historyData.requestFor.photo;
            historyData['requestforempno'] = historyData.requestFor.empNo;
            historyData['signedby'] = historyData.letterSignee;
            historyData['signedbyuserid'] = historyData.signedBy ? historyData.signedBy.userId : '';
            historyData['signedbyname'] = historyData.signedBy ? historyData.signedBy.fullName : '';
            historyData['signedbyphoto'] = historyData.signedBy ? historyData.signedBy.photo : '';
            historyData['signedbyempno'] = historyData.signedBy ? historyData.signedBy.empNo : '';
            historyData['companyId'] = historyData.companyId;
            historyData['templateCode'] = historyData.letterType;
            historyData['refdate'] = historyData.referencedate;
          }
          resolve(historyData);
        }, error => {
          reject()
          console.log("error", error);
        }
        )
      )
    })
  }

  async history(payload): Promise<void> {
    console.log('BLOC | history', payload)
    return new Promise<any>(async (resolve, reject) => {
      this.subscriptions.push(
        this.letterSf6Api.history(payload.empId, payload.limit, payload.skip).subscribe(async result => {
          let historyData = [];
          if (result.data.length > 0) {
            historyData['data'] = result.data;
          } else {
            historyData['data'] = [];
          }
          resolve(result);
        }, error => {
          reject(error)
          console.log("BLOC | error", error);
        }
        )
      )
    })
  }

  showButton(requestNo: string): Observable<any> {
    console.log("BLOC | showButton", requestNo);
    return this.workFlowApiProvider.showButton(requestNo).pipe(map(result => result.data));
  }

  listing(payload): Observable<any> {
    return this.letterSf6Api.listing(payload.empId).pipe(map(result => result.data));
  }

  previewLetter(letterNo): Observable<any> {
    return this.letterSf6Api.previewLetterNew(letterNo).pipe(map(result => result.data));
  }

  downloadPdf(letterNo): Observable<any> {
    this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_PDF);
    return this.letterSf6Api.downloadPdf(letterNo);
  }

  generatePdf(data) {
    if (this.platform.is('cordova')) {
      this.fileDownloaderProvider.downloadPdfBlob(data, 'Employee Letter')
    } else {
      saveAs(data, 'Employee Letter.pdf')
    }
  }
}



// WEBPACK FOOTER //
// ./src/bloc/hr/employee/letter.bloc.ts